export default function FruitSlicerIcon() {
  return (
    <svg viewBox="0 0 64 64" aria-hidden="true" fill="none">
      <path d="M6 30a22 22 0 0 0 44 0z" fill="#2f8f3a" transform="rotate(-20 28 30)" />
      <path d="M10 30a18 18 0 0 0 36 0z" fill="#ff4f63" transform="rotate(-20 28 30)" />
      <g fill="#2a1a12" transform="rotate(-20 28 30)">
        <ellipse cx="20" cy="37" rx="1.6" ry="2.6" />
        <ellipse cx="28" cy="40" rx="1.6" ry="2.6" />
        <ellipse cx="36" cy="37" rx="1.6" ry="2.6" />
      </g>
      <circle cx="44" cy="20" r="11" fill="#ff9a1f" />
      <circle cx="40.5" cy="16.5" r="3" fill="#ffd28a" />
      <path d="M4 58L60 6" stroke="#fff" strokeWidth="5" strokeLinecap="round" />
      <path d="M4 58L60 6" stroke="#7fdcff" strokeWidth="2" strokeLinecap="round" />
      <circle cx="14" cy="14" r="3" fill="#ff5470" />
      <circle cx="52" cy="46" r="2.5" fill="#ffad33" />
    </svg>
  );
}
